<dx-popup #employeeProfilePopup [width]="800" height="auto" [showTitle]="true" title="Your Account"
    (onShowing)="onShowing($event)" [dragEnabled]="false" [showCloseButton]="true" [hideOnOutsideClick]="false"
    [(visible)]="popupVisible">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="SaveButtonOptions">
    </dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <!-- <form autocomplete="off"> -->
            <dx-form [formData]="employee" autocomplete="off" (onInitialized)="onInitialized($event)">
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item dataField="Title" [editorOptions]="{}"></dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item dataField="FirstName">
                        <dxi-validation-rule type="required"
                            [message]="constants.RequiredFieldMessage('employee','first name')">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="LastName">
                        <dxi-validation-rule type="required"
                            [message]="constants.RequiredFieldMessage('employee','last name')">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="MobileTelephone" template="mobileTelephoneTemplate">
                        <dxi-validation-rule type="custom" [validationCallback]="validateMobileFormat"
                            [message]="'Please enter a valid mobile telephone number.'">
                        </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2" caption="Change PIN">
                    <dxi-item dataField="ChangePIN1"
                        [editorOptions]="{ mask:'0000', maskChar:' ',maxLength:4, inputAttr: {autocomplete: 'new-password'}}">
                        <dxo-label text="New PIN">
                        </dxo-label>
                        <dxi-validation-rule type="custom" message="PIN number must be 4 digits long" reevaluate="true"
                            [validationCallback]="CheckPINLength1">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="ChangePIN2"
                        [editorOptions]="{ mask:'0000', maskChar:' ',maxLength:4, inputAttr: {autocomplete: 'new-password'}}">
                        <dxo-label text="Confirm PIN">
                        </dxo-label>
                        <dxi-validation-rule type="compare" [comparisonTarget]="pinComparison1" reevaluate="true"
                            message="New PIN and Confirm PIN do not match">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="custom" message="PIN number must be 4 digits long" reevaluate="true"
                            [validationCallback]="CheckPINLength2">
                        </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2" [colSpan]="2" caption="Change Password">
                    <dxi-item dataField="ChangePassword1"
                        [editorOptions]="{ mode:'password', inputAttr: {autocomplete: 'new-password'}}">
                        <dxo-label text="New Password">
                        </dxo-label>
                        <dxi-validation-rule type="custom" [message]="constants.PasswordMessage" reevaluate="true"
                            [validationCallback]="CheckPasswordLength1">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="pattern" [pattern]="constants.PasswordPattern" reevaluate="true"
                            [message]="constants.PasswordMessage">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="ChangePassword2"
                        [editorOptions]="{ mode:'password', inputAttr: {autocomplete: 'new-password'}}">
                        <dxo-label text="Confirm Password">
                        </dxo-label>
                        <dxi-validation-rule type="custom" [message]="constants.PasswordMessage" reevaluate="true"
                            [validationCallback]="CheckPasswordLength2">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison" reevaluate="true"
                            message="New Password and Confirm Password do not match">
                        </dxi-validation-rule>
                        <dxi-validation-rule type="pattern" [pattern]="constants.PasswordPattern" reevaluate="true"
                            [message]="constants.PasswordMessage">
                        </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
                <div *dxTemplate="let data of 'mobileTelephoneTemplate'" style="display: flex; flex-direction: row;">                
                    <dx-lookup [dataSource]="countries" valueExpr="this" itemTemplate="countryItemTemplate"
                        fieldTemplate="countryFieldTemplate" (onValueChanged)="onMobileISDSelected($event)" [searchExpr]="['name', 'prefixedISD']">
                        <dxo-drop-down-options [width]="450" [height]="500" [showTitle]="false" [toolbarItems]="[]">
                        </dxo-drop-down-options>
                        <div *dxTemplate="let data of 'countryFieldTemplate'">
                            +{{country?.ISD}}
                        </div>
                        <div *dxTemplate="let country of 'countryItemTemplate'">
                            <span [ngClass]="'fi fi-' + country?.ISO2.toLowerCase()"></span>
                            {{country?.name}}
                            +{{country?.ISD}}
                        </div>
                    </dx-lookup>
                    <dx-text-box [(value)]="employeeMobileDisplayValue" [placeholder]="country?.exampleNSN"
                        (onInput)="onMobileInput($event)">
                    </dx-text-box>                    
                </div>
            </dx-form>
        <!-- </form> -->
    </div>
</dx-popup>